export default __webpack_public_path__ + "static/media/carouselPreganncyLogo1.47c53936.png";